import React from "react";

import {
  isIdentical,
  isObjectEmpty,
  saveMap,
  saveParseJson,
  setLocalStorageItem,
} from "data/functions";
import MaxLogo from "data/images/max.svg";
import TelegramLogo from "data/images/telegram.svg";
import VkLogo from "data/images/vk.svg";
import WebLogo from "data/images/web.svg";
export const ChannelsContext = React.createContext();

function parseChannels(array) {
  // if (isObjectEmpty(array)) return [];
  let res = [];
  saveMap(array, "parseChannels").forEach((element) => {
    if (element.name === "Telegram" && element?.info?.data) {
      res = [
        ...res,
        {
          color1: "#7cb4d5",
          color2: "#2c98d8",
          footer: element?.info?.data ? "@" + element?.info?.data : "",
          header: "Подключайтесь\nк Telegram-боту!",
          id: element.name,
          logo: TelegramLogo,
          type: "telegram",
          url: "https://t.me/" + element?.info?.data,
        },
      ];
    }
    if (element.name === "Max" && element?.info?.data) {
      res = [
        ...res,
        {
          color1: "#3846dbff",
          color2: "#8D28C8",
          footer: element?.info?.data ? element?.info?.data : "",
          header: "Подключайтесь\nк MAX-боту!",
          id: element.name,
          logo: MaxLogo,
          type: "max",
          url: "https://max.ru/" + element?.info?.data,
        },
      ];
    }
    if (element.name === "Vk" && element?.info?.data) {
      res = [
        ...res,
        {
          color1: "#0077FF",
          color2: "#666dbbff",
          footer: element?.info?.data ? "club" + element?.info?.data : "",
          header: "Присоединяйтесь к сообществу\nВКонтакте!",
          id: element.name,
          logo: VkLogo,
          type: "vk",
          url: "https://vk.ru/club" + element?.info?.data,
        },
      ];
    }
    if (element.name === "Link" && element?.info?.url) {
      res = [
        ...res,
        {
          color1: "#5f86db",
          color2: "#4b6aac",
          footer: element?.info?.url,
          header: "Воспользуйтесь личным \nкабинетом на сайте!",
          id: element.name,
          logo: WebLogo,
          type: "link",
          url: element?.info?.url,
        },
      ];
    }
  });
  // if (res.length === 0) {
  res = [
    ...res,
    {
      // disableQR: true,
      id: "Default",
      // footer: "Ожидание..",
      // header: "Воспользуйтесь\nличным кабинетом на сайте!",
      type: "temp",
      // url: element?.info?.url,
    },
  ];
  // }
  return res ?? [];
}

export const reducer = (state, action) => {
  switch (action.type) {
    case "addChannels": {
      let existChannels = state?.channels || [];
      let newChannels = parseChannels(action?.channels);
      // let newChannels = parseChannels([]);

      if (!isIdentical(existChannels, newChannels)) {
        setLocalStorageItem("channels_array", newChannels);
        return {
          ...state,
          channels: newChannels,
        };
      } else return state;
    }
    case "changeStatus": {
      let exist = state?.statuses[action?.id];
      if (exist === undefined) exist = true;
      if (!isIdentical(exist, action.status)) {
        let res = {
          ...state,
          statuses: {
            ...state.statuses,
            [action?.id]: !exist,
          },
        };
        setLocalStorageItem("channels_statuses", res?.statuses);
        return res;
      } else return state;
    }
    case "setParam": {
      if (!isIdentical(state[action.paramName], action.paramValue)) {
        return {
          ...state,
          [action.paramName]: action.paramValue,
        };
      } else return state;
    }
    case "deleteChannels": {
      return {
        ...state,
        channels: [],
      };
    }
    default:
      return state;
  }
};

export const initialState = {
  channels: [],
  statuses: {},
};

function ChannelsProvider({ children }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const value = {
    addChannels: React.useCallback(
      (channels) =>
        dispatch({
          channels: channels,
          type: "addChannels",
        }),
      []
    ),
    changeStatus: React.useCallback(
      (id) =>
        dispatch({
          id: id,
          type: "changeStatus",
        }),
      []
    ),
    channels: state.channels,
    deleteChannels: React.useCallback(
      () =>
        dispatch({
          type: "deleteChannels",
        }),
      []
    ),
    setParam: React.useCallback(
      (name, value) =>
        dispatch({
          paramName: name,
          paramValue: value,
          type: "setParam",
        }),
      []
    ),
    statuses: state?.statuses,
  };

  React.useEffect(() => {
    for (let i = 0; i < localStorage.length; i++) {
      let key = localStorage.key(i);
      let value = undefined;
      if (key.includes("channels_"))
        try {
          value = saveParseJson(localStorage.getItem(key));
          if (!isObjectEmpty(value)) {
            dispatch({
              paramName: key.replace("channels_", ""),
              paramValue: value,
              type: "setParam",
            });
          }
          // eslint-disable-next-line prettier/prettier
        } catch {}
    }
  }, []);

  return (
    <ChannelsContext.Provider value={value}>
      {children}
    </ChannelsContext.Provider>
  );
}
export const GetChannels = () => {
  const context = React.useContext(ChannelsContext);
  return context;
};

export { ChannelsProvider };
